import { Box, Card, Grid, Typography } from '@mui/material'
import React from 'react'
import BannerBg from './../Assets/bannerBg.png';
import SectionTitle from './SectionTitle';

const ImpactSection = ({ impact }) => {
    const { header_title = [], header_desc = '', cards = [] } = impact || {};
    return (
        <Box sx={{
            backgroundImage: `url(${BannerBg})`,
            backgroundSize: 'contain',
            p: 5,
        }}>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <SectionTitle align='center' variant={'h4'} header={header_title} />
                    <Typography variant="body1" sx={{ textAlign: "center", mb: 4 }}>
                        {header_desc}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                {cards.map((item, index) => (
                    <Grid item xs={12} sm={6} md={6} lg={3} key={index}>
                        <Card 
                            sx={{ textAlign: "center", py: 4,
                                borderRadius: '10px',
                                background: 'rgba(255, 255, 255, 0.7)',
                                backdropFilter: 'blur(2.5px)',
                                WebkitBackdropFilter: 'blur(2.5px)',
                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
                                borderRadius: '10px',
                            }}>
                            <Typography variant="h4" sx={{ color: "orange", fontWeight: "bold", mb: 2 }}>
                                {item?.count}
                            </Typography>
                            <Typography variant="body1" sx={{fontWeight: 'bold', color: '#33363F'}}>{item?.title}</Typography>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default ImpactSection